import { cn } from '@fruuit/ui'
import { Link } from 'react-router'
import type { AreaId } from '../api/types'
import { AREAS, permittedAreas } from '../areas/areas'
import { useSession } from '../auth/session-context'

/** Investor / Workspace / Admin, showing only the areas in `me.areas`. Hidden with one area. */
export function AreaSwitcher({
  current,
  orientation = 'horizontal',
  className,
}: {
  current: AreaId
  orientation?: 'horizontal' | 'vertical'
  className?: string
}) {
  const me = useSession()
  const areas = permittedAreas(me)
  if (areas.length < 2) return null

  return (
    <nav aria-label="Switch area" className={className}>
      <ul
        className={cn(
          'flex gap-1 rounded-lg bg-wash p-1 ring-1 ring-line',
          orientation === 'vertical' && 'flex-col',
        )}
      >
        {areas.map((id) => {
          const active = id === current
          return (
            <li key={id} className={orientation === 'vertical' ? undefined : 'flex'}>
              <Link
                to={AREAS[id].basePath}
                aria-current={active ? 'true' : undefined}
                className={cn(
                  'flex items-center rounded-md px-3 py-1.5 text-[13px] no-underline transition-colors',
                  active
                    ? 'bg-surface font-semibold text-teal shadow-[0_1px_2px_rgb(22_62_58/0.12)] ring-1 ring-line'
                    : 'font-medium text-sage hover:bg-wash-strong hover:text-ink',
                )}
              >
                {AREAS[id].label}
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
